export default __webpack_public_path__ + "img/chcKKVXO.a7ade570.svg";